<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
const WorkOrderItemsRepository = Repositories.get('workorderitems');
import ReserveItems from './reserve-items.vue';
import OrderItems from './order-items.vue';

const RESERVATION_STEPS = Object.freeze({
  RESERVATIONS: 'reservations',
  ORDERS: 'orders',
});

export default {
  components: {
    Loading,
    ReserveItems,
    OrderItems,
  },
  props: {
    modalInfo: Object,
  },
  data() {
    return {
      workOrderItem: null,
      item: null,
      isLoading: false,
      reservationStep: RESERVATION_STEPS.RESERVATIONS,
    };
  },
  methods: {
    modalHidden() {
      this.$emit('wo-item-updated', this.workOrderItem);
      this.item = null;
      this.workOrderItem = null;
      this.reservationStep = RESERVATION_STEPS.RESERVATIONS;
      this.$emit('modal-closed');
    },
    modalShown() {
      this.reservationStep = RESERVATION_STEPS.RESERVATIONS;
      this.workOrderItem = null;
      this.item = null;
      this.refreshItems();
    },
    updateWorkOrderItem() {
      WorkOrderItemsRepository.get(this.modalInfo.idPublic)
        .then((response) => {
          this.workOrderItem = response.data;

          let {
            reservedQuantity,
            orderedQuantity,
            consumedQuantity,
            requestedQuantity,
            totalQuantity,
          } = this.workOrderItem;
          if (
            reservedQuantity +
              orderedQuantity +
              consumedQuantity +
              requestedQuantity >=
            totalQuantity
          ) {
            this.$bvModal.hide('manage-reservations-modal');
          } else {
            this.reservationStep = RESERVATION_STEPS.ORDERS;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    requestReserve(apiWrapper) {
      this.isLoading = true;
      WorkOrderItemsRepository.actions
        .updateRequestedReserved(apiWrapper, this.workOrderItem.idPublic)
        .then((resp) => {
          if (resp.data != null && resp.data == true) {
            this.updateWorkOrderItem();
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.refreshItems();
          }
        })
        .catch((error) => {
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgain'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.refreshItems();
        });
    },
    refreshItems() {
      this.isLoading = true;
      let promise1 = ItemsRepository.get(this.modalInfo.itemIdPublic).then(
        (response) => {
          this.item = response.data;
        }
      );
      let promise2 = WorkOrderItemsRepository.get(this.modalInfo.idPublic).then(
        (response) => {
          this.workOrderItem = response.data;
        }
      );

      Promise.all([promise1, promise2])
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    orderSection() {
      this.reservationStep = RESERVATION_STEPS.ORDERS;
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="manage-reservations-modal"
      scrollable
      size="lg"
      :title="$t('general.reserve')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>
      <div v-if="item != null && workOrderItem != null">
        <ReserveItems
          v-if="reservationStep == 'reservations'"
          :workOrderItem="workOrderItem"
          :item="item"
          @request-reserve="requestReserve"
          @refresh-items="refreshItems"
          @order-section="orderSection"
        />
        <OrderItems
          v-if="reservationStep == 'orders'"
          :workOrderItem="workOrderItem"
          :item="item"
          @request-reserve="requestReserve"
          @refresh-items="refreshItems"
          @update-work-order-item="updateWorkOrderItem"
          @close-modal="$bvModal.hide('manage-reservations-modal')"
        />
      </div>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('manage-reservations-modal')"
          size="sm"
          variant="danger"
        >
          {{ $t('general.close') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>